import { render, staticRenderFns } from "./BaseImageViewer.vue?vue&type=template&id=26dd48a0&"
import script from "./BaseImageViewer.vue?vue&type=script&lang=js&"
export * from "./BaseImageViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports